import { format, parseISO } from "date-fns";
import { GridCellParams } from "@mui/x-data-grid";
import { useIntl } from "react-intl";

import { humanReadableDateTimeFormat } from "@dzambalaorg/constants";
import { AddressLink } from "@dzambalaorg/mui-scanner";

// prettier-ignore
export const achievementsColumnsCreator = (formatMessage: ReturnType<typeof useIntl>["formatMessage"]) =>  [
  {
    field: "id",
    headerName: formatMessage({ id: "form.labels.id" }),
    sortable: true,
    flex: 0.3
  },
  {
    field: "account",
    headerName: formatMessage({ id: "form.labels.account" }),
    sortable: true,
    renderCell: (params: GridCellParams<any, string>) => {
      return (
        <AddressLink address={params.value} />
      );
    },
    flex: 2,
    minWidth: 360
  },
  {
    field: "title",
    headerName: formatMessage({ id: "form.labels.title" }),
    sortable: true,
    flex: 1,
    minWidth: 80
  },
  {
    field: "createdAt",
    headerName: formatMessage({ id: "form.labels.createdAt" }),
    sortable: true,
    valueFormatter: (value: string) => format(parseISO(value), humanReadableDateTimeFormat),
    flex: 1,
    minWidth: 160
  }
];
